export const StatementSkeletonStyle = ({ theme }) => ({
  background:
    'linear-gradient(90deg, #C7C7C7 0%, rgba(199, 199, 199, 0.00) 99.88%, rgba(199, 199, 199, 0.00) 99.89%)',
  borderRadius: '8px!important',
  height: '48px!important',
  margin: '14px 0!important',
  [theme.breakpoints.up('md')]: {
    borderRadius: '12px!important',
    height: '80px!important',
    margin: '16px 0!important'
  }
});

export const LoadingContainerStyle = ({ theme }) => ({
  padding: '0 4px',
  marginTop: '44px',
  [theme.breakpoints.up('md')]: {
    marginTop: '52px'
  }
});

export const LongLoadingContainerStyle = ({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '28px',
  [theme.breakpoints.up('md')]: {
    marginTop: '38px'
  }
});

export const DividerStyle = () => ({
  // TODO: this color is not in the theme
  backgroundColor: '#EEE'
});
